"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseSelectionBehaviour_1 = require("../grids/selectBehaviours/BaseSelectionBehaviour");
var IGridTextField = (function (_super) {
    __extends(IGridTextField, _super);
    function IGridTextField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IGridTextField;
}(zebra.ui.TextField));
exports.IGridTextField = IGridTextField;
exports.gridTextField = zebra.Class(zebra.ui.TextField, [
    function (grid, row, col, txt, maxCol) {
        this._grid = grid;
        this._row = row;
        this._col = col;
        this.$super(txt, maxCol);
    },
    function keyPressed(e) {
        this.$super(e);
        if (e.code === BaseSelectionBehaviour_1.KEYS.ENTER && this._row < this._grid.getGridRows() - 1) {
            this._grid.startEditing(this._row + 1, this._col);
        }
    }
]);
//# sourceMappingURL=gridTextField.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/uiElements/gridTextField.js
// module id = 26
// module chunks = 0